export default ({ app, context }, inject) => {
const validator = {
	// get~ : return temporary value
	getIntegerDate(dateString) {
		return parseInt(dateString.replace(/\//g, ''), 10);
	},
	getIntegerTime(timeString) {
		return parseInt(timeString.slice(0,5).replace(/:/, ''), 10);
	},
	getSubDateStrings(value, base = '') {
		if (!this.isString(value) || !this.isFormatDate(value)) return 0;
		let dateString = this.isString(base) && this.isFormatDate(base) ? base : app.$timeutil.getNowDate();
		return this.getIntegerDate(dateString) - this.getIntegerDate(value);
	},
    // is~ : return bool
    isBeforeOrSameDate(value, base = '') {
        return this.getSubDateStrings(value, base) >= 0;
    },
    isBeforeOrSameTime(value, base = {}) {
		let subDate = base.sub;
		if (subDate === true) return true;
		if (subDate === false) return false;
		if (!Number.isInteger(subDate)) {
			subDate = this.getSubDateStrings(value, base.date || '')
		}
		if (subDate < 0) return false;
		if (subDate) return true;
		let baseTime = base.time || '';
		if (!this.isString(baseTime) || !this.isFormatTimePartial(baseTime)) baseTime = app.$timeutil.getNowDatetime().slice(-5);
        return this.getIntegerTime(baseTime) - this.getIntegerTime(value) > -1;
    },
    isFormatDate(value) {
        return (/^2[0-9]{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/.test(value));
    },
    isFormatDateHyphen(value) {
        return (/^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(value));
    },
    isFormatTime(value) {
        return (/^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(value));
    },
    isFormatTimePartial(value) {
        return (/^([01][0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test(value));
    },
    isString(value) {
        return typeof value === 'string'
            || value instanceof String
        ;
    },
    isWithinMaxRange (before, after, range) {
        // Date Object を使う理由: 「2月30日」など、存在しない日付になった時の処理のため
		let dateObj = app.$timeutil.strToDateObject(before);
        const rangeInt = parseInt(range.substr(1), 10);
        switch (range.substr(0, 1)) {
            case 'y':
                dateObj.setFullYear(dateObj.getFullYear() + rangeInt, dateObj.getMonth(), dateObj.getDate());
                break;
            case 'm':
                dateObj.setMonth(dateObj.getMonth() + rangeInt);
                break;
            case 'd':
                dateObj.setDate(dateObj.getDate() + rangeInt);
                break;
		}
		return dateObj.getTime() >= app.$timeutil.strToDateObject(after).getTime();
    },
    isZenkaku(value, i = 0) {
        const c = value.charCodeAt(i);
        return c > 0x80
        && (c <= 0xff60 || c >= 0xffe0) // hankaku kana
        ;
    },
    // validate~ : return true or validation message
    validateArray(value) {
        return Array.isArray(value)
            || 'タイプが間違っています'
        ;
    },
    validateBeforeOrSameTime(value, base = {}, baseKey = '') {
        return this.isBeforeOrSameTime(value, base)
            || baseKey + (baseKey.length > 0 ? 'より' : '') + '未来の時刻は指定できません'
        ;
    },
    validateBeforeOrSameDate(value, date = '', baseKey = '') {
        return this.isBeforeOrSameDate(value, date)
            || baseKey + (baseKey.length > 0 ? 'より' : '') + '未来の日付は指定できません'
        ;
    },
    validateConfirm(value, passwd) {
        return value == passwd
        || '新しいパスワードと一致しません'
    },
    validateFile(value) {
        return (value instanceof File)
            || 'ファイルを選択してください'
        ;
    },
    validateFormatDate(value) {
        return this.isFormatDate(value)
            || '日付のフォーマットは「YYYY/MM/dd」です'
        ;
    },
    validateFormatEmail(v) {
        return (!v || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v))
            || 'メールアドレス形式が不正です'
        ;
    },
    validateFormatTime(value) {
        return this.isFormatTime(value)
            || '時間のフォーマットは「HH:mm」です'
        ;
    },
    validateInArray(value, array) {
        return array.includes(value)
            || '選択肢から選んでください'
        ;
    },
    validateMaxFileCount(value, count) {
        return value.length <= count
            || `${count + 1}個以上のファイル送信はできません`
        ;
    },
    validateMaxStringLength(v, length, key) {
        return (!v || v.replace(/\r\n/g, '\n').length <= length)
        || (key ? `${key}は` : '') + `${length}文字以内です`;
    },
    validateMaxUploadSize(value, mb_size) {
        const totalSize = value.reduce((acc, cur) =>
            acc + cur.size
        ,0);
        return totalSize <= (mb_size * 1024 * 1024)
            || `合計${mb_size}MB以上のファイルは送信できません`
        ;
    },
    validateMaxZenkakuLength(v, length, key) {
        let zenLength = 0;
        for (let i = 0; i < v.length; i++) {
            if (v[i].match(/\r?\n/)) continue;
            if (this.isZenkaku(v, i)) {
                zenLength += 1;
            } else {
                zenLength += 0.5;
            }
        }
        return (zenLength <= length)
        || (key ? `${key}は` : '') + `${length}文字以内です`;
    },
    validatePassword(value) {
        return /^(?=.*?[a-z])(?=.*?\d).*[!-~]{8,}$/i.test(value)
        || '半角の英字と数字を混ぜた8文字以上が必須です';
    },
    validateRequired(value, except = true) {
        return (!!value || !except)
            || '必須項目です'
        ;
    },
};

    inject('validator', validator);
}
